import { Link } from "react-router-dom";

export type Crumb = {
  label: string;
  to?: string;
};

type BreadcrumbProps = {
  items: Crumb[];
};

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="text-xs text-foreground-500">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-2">
              {item.to && !isLast ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? "text-foreground-800" : ""} aria-current={isLast ? "page" : undefined}>
                  {item.label}
                </span>
              )}
              {!isLast ? <i className="ri-arrow-right-s-line text-sm text-background-400" aria-hidden="true" /> : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}